// The BcfActivatedRoute class is a service that provides information about the active route.
// It provides the fragment, queryParams and params of the active route.
// It is used by the components to get the information about the active route.
import { BcfActivatedUrlContract } from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-activated-url';
import { ActivatedUrl } from '@tmf-shared-platform/activated-url/activated-url';
import { type Observable } from 'rxjs';

export class BcfActivatedUrlAdapter implements BcfActivatedUrlContract {
  constructor(private _activatedUrl: ActivatedUrl) {}

  public get url$(): Observable<string> {
    return this._activatedUrl.url$;
  }

  public get fullUrl$(): Observable<string> {
    return this._activatedUrl.fullUrl$;
  }

  public get originUrl$(): Observable<string> {
    return this._activatedUrl.originUrl$;
  }
}
